import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { getAlertsRoutes } from "@pages/alerts/get-alerts-routes";
import { getAnnualStatementsRoutes } from "@pages/annual-statements/get-annual-statements-routes";
import { getAsicInvoicesRoutes } from "@pages/asic-invoices/get-asic-invoices-routes";
import { getBulkChangesRoutes } from "@pages/bulk-changes/get-bulk-changes-routes";
import { getBulkSendForESignRoutes } from "@pages/bulk-send-for-esign/get-bulk-send-for-e-sign-routes";
import { getCompaniesRoutes } from "@pages/companies/get-companies-routes";
import { getDocumentsRoutes } from "@pages/documents/get-documents-routes";
import { getIndividualsRoutes } from "@pages/individuals/get-individuals-routes";
import { getOutgoingMessagesRoutes } from "@pages/outgoing-messages/get-outgoing-messages-routes";
import { getRedirectsRoutes } from "@pages/redirects/get-redirects-routes";
import { getSettingsRoutes } from "@pages/settings/get-settings-routes";
import { getSharesRoutes } from "@pages/shares/get-shares-routes";
import { getSuperusersRoutes } from "@pages/superuser/get-superusers-routes";
import { getTrustsRoutes } from "@pages/trusts/get-trusts-routes";

const routes: Routes = [
  { path: '', redirectTo: '/companies', pathMatch: 'full' },

  ...getCompaniesRoutes(),
  ...getTrustsRoutes(),
  ...getAlertsRoutes(),
  ...getAnnualStatementsRoutes(),
  ...getIndividualsRoutes(),
  ...getDocumentsRoutes(),
  ...getBulkChangesRoutes(),
  ...getBulkSendForESignRoutes(),
  ...getSharesRoutes(),
  ...getSettingsRoutes(),
  ...getOutgoingMessagesRoutes(),
  ...getAsicInvoicesRoutes(),

  ...getRedirectsRoutes(),

  ...getSuperusersRoutes(),

  { path: '**', redirectTo: '/companies' },
];

function initializeAuthService(authService: AuthService): () => Promise<void> {
  return () => authService.init();
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuthService,
      deps: [AuthService],
      multi: true
    }
  ],
})
export class AppRoutingModule {}
